import "./CustomerCardStyles.css"

import React from 'react'


const CustomerCard = (props) => {
  return (
    <div className="customer-card">
        <img src={props.imgsrc} alt="customerimage" />
    </div>

  )
}

export default CustomerCard